var i="\nvoid main(void) {\n    gl_Position = getPosition();\n";export{i as default};
